import commonSlice from "./Common/commonSlice";
import contactSlice from "./Contact/contactSlice";
import homeDataSlice from "./Home/homeDataSlice";

export const rootReducers = {
  homeData: homeDataSlice,
  contact: contactSlice,
  common: commonSlice,
};
